type RGB = { r: number; g: number; b: number }

// Parses #rrggbb or rgb()/rgba() strings
export const parseColor = (color?: string): RGB | null => {
  if (!color) {
    return null
  }
  const hex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color.trim())
  if (hex) {
    return { r: parseInt(hex[1], 16), g: parseInt(hex[2], 16), b: parseInt(hex[3], 16) }
  }
  const rgb = /rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/.exec(color)

  return rgb ? { r: Number(rgb[1]), g: Number(rgb[2]), b: Number(rgb[3]) } : null
}

// Perceived brightness (YIQ), 0-255
const brightness = ({ r, g, b }: RGB) => (r * 299 + g * 587 + b * 114) / 1000

export const getBrightness = (color: string): number => {
  const rgb = parseColor(color)

  return rgb ? brightness(rgb) : 128
}

// Unparseable colors count as light
export const isDarkColor = (color: string | undefined, threshold = 128) => {
  const rgb = parseColor(color)

  return rgb !== null && brightness(rgb) < threshold
}

export const colorIsValid = (color: string): boolean => /^#?[0-9A-F]{6}$/i.test(color)

export const colorWithHash = (color: string): string => (color.startsWith("#") ? color : `#${color}`)
